export enum TABLE_FIELD_TYPE {
    RADIOBTN = "RADIO",
    SELECT = "SELECT",
}